import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const totalUser = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};

/* 대시보드 응급상황 처리현황api */
export const fetchDailyEmergencyGraph = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/dashboard-graph/1`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchWeeklyEmergencyGraph = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/dashboard-graph/2`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMonthlyEmergencyGraph = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/dashboard-graph/3`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 응급상황 현황
// 응급상황 리스트 불러오기
// TODO : 500 error시 예외처리
export const fetchEmergencyAlerts = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/dashboard-alert`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("🚨 응급상황 리스트 조회 실패:", error);
    return { success: false, message: '응급상황 데이터를 불러오지 못했습니다.', data: [] };
  }
};

export const fetchEmergencyCount = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/dashboard-alert/count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // 여기서 { success, emergency_end_count } 같은 값이 올 거예요
  } catch (error) {
    console.error("🚨 상황종료 카운트 조회 실패:", error);
    return { success: false, message: "상황종료 카운트 조회에 실패했습니다." };
  }
};
export const submitEmergencyEnds = async (token) => {
  console.log("토큰:", token);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/dashboard-alert/end`,
      {}, // POST body가 필요 없으면 빈 객체
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    console.log("응답:", response.data);
    return response.data;
  } catch (error) {
    console.error("🚨 상황종료 등록 실패:", error);
    return { success: false, message: "상황종료 등록에 실패했습니다." };
  }
};

export const checkEmergencyAlert = async (alert_id, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/dashboard-alert/check`,
      { alert_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data; // { success, message, report_id }
  } catch (error) {
    console.error("🚨 응급상황 접수 실패:", error);
    return { success: false, message: "응급상황 접수 실패" };
  }
};




// 응급처리 내용 저장
export const submitEmergencyLog = async (token, report_id, content) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/dashboard-alert/log`,
      { report_id, content },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    const { success, alert_log_id } = response.data;

    if (success && alert_log_id) {
      // /check로 alert_log_id 전송
      await axios.post(`${API_BASE_URL}/check`, {
        alert_id: alert_log_id,
      });
    }

    return response.data;
  } catch (error) {
    console.error('응급처리 저장 실패', error);
    return { success: false };
  }
};


export const dismissThirdLevelAlert = async (alert_id, token) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/check`,
      { alert_id }, // 🔸 body로 alert_id 전송
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  } catch (error) {
    console.error('❌ 3차 알림 닫기 실패:', error);
    return { success: false };
  }
};

export const fetchAbnormalLogs = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/log-abnormal`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("✅ 이상 알림 로그 응답:", response.data);
    return response.data;
  } catch (error) {
    console.error("🚨 이상 알림 로그 조회 실패:", error);
    return { success: false };
  }
};
